export const Social = ({children, padding}) => {
    return (
        <div className="am-social" style={{padding: padding}}>
            {children}
        </div>
    );
};
